/* global axios */
import ApiClient from './ApiClient';

class BmtCampaignsAPI extends ApiClient {
  constructor() {
    super('bmt_campaigns', { accountScoped: true });
  }

  uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/upload_image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  uploadContacts(campaignId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${campaignId}/upload_contacts`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  trigger(campaignId) {
    return axios.post(`${this.url}/${campaignId}/trigger`);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }

  cancel(campaignId) {
    return axios.post(`${this.url}/${campaignId}/cancel`);
  }

  stats(campaignId) {
    return axios.get(`${this.url}/${campaignId}/stats`);
  }

  getContacts(campaignId, page = 1) {
    return axios.get(`${this.url}/${campaignId}/contacts`, { params: { page } });
  }

  // Sprint #47.22 -- baixa XLSX com todos os contatos da campanha QR
  exportContacts(campaignId) {
    return axios.get(`${this.url}/${campaignId}/export`, { responseType: 'blob' });
  }

  destroy(campaignId) {
    return axios.delete(`${this.url}/${campaignId}`);
  }
}

class BmtEvolutionInboxesAPI extends ApiClient {
  constructor() {
    super('bmt_evolution_inboxes', { accountScoped: true });
  }

  register(inboxId, instanceName) {
    return axios.post(this.url, { inbox_id: inboxId, instance_name: instanceName });
  }

  restart(id) {
    return axios.post(`${this.url}/${id}/restart`);
  }

  disconnect(id) {
    return axios.post(`${this.url}/${id}/disconnect`);
  }
}

export const BmtCampaignsApi = new BmtCampaignsAPI();
export const BmtEvolutionInboxesApi = new BmtEvolutionInboxesAPI();
